/*
 * Download de arquivo gerado pelo back (resposta do useCreateFile, com o Blob em
 * `response.data`): o nome vem do header Content-Disposition (`filename*=UTF-8''...`
 * ou `filename="..."`); sem ele, vale o nome padrão.
 */
export const nomeArquivoDaResposta = (headers, nomePadrao) => {
    const disposition = headers && (headers['content-disposition'] || headers['Content-Disposition']);
    if (!disposition) {
        return nomePadrao;
    }

    const codificado = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (codificado) {
        try {
            return decodeURIComponent(codificado[1].trim().replace(/^"|"$/g, ''));
        } catch (e) {
            // Nome mal codificado: tenta o filename simples.
        }
    }

    const simples = disposition.match(/filename\s*=\s*"?([^";]+)"?/i);
    return simples ? simples[1].trim() : nomePadrao;
};

export const salvarArquivoResposta = (response, nomePadrao) => {
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');

    link.href = url;
    link.download = nomeArquivoDaResposta(response.headers, nomePadrao);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
};
